class TableToggler extends HTMLElement {
    connectedCallback() {
        // Initially display the first table inside this custom element.
        const firstTable = this.querySelector('table');
        if (firstTable) {
            const tableId = firstTable.id;
            const buttonId = tableId.replace("table_", "btn_");
            this.showTable(tableId, buttonId);
        }

        this.querySelectorAll("button").forEach(button => {
            button.addEventListener("click", () => {
                const buttonId = button.id;
                const tableId = buttonId.replace("btn_", "table_");
                this.showTable(tableId, buttonId);
            });
        });
    }

    showTable(tableId, buttonId) {
        this.hideAllTables();
        const table = this.querySelector("#" + tableId);
        const button = this.querySelector("#" + buttonId);
        if (table && table.parentElement) {
            table.parentElement.style.display = "block";
            button.classList.add("selected");
        }
    }

    hideAllTables() {
        const tables = this.querySelectorAll("table");
        tables.forEach(table => {
            if (table.parentElement) {
                table.parentElement.style.display = "none";
            }
        });

        // Remove the 'selected' class from all buttons
        this.querySelectorAll("button").forEach(button => {
            button.classList.remove("selected");
        });
    }
}

// Define the custom element
customElements.define('table-toggler', TableToggler);
